import { useQuery, useMutation } from '@tanstack/react-query';
import clientPortalAxiosInstance from '../../common/utilities/axios/clientPortalAxiosInstance';
import sleep from 'sleep-promise';

export const useViewAccountTeamMembersListQuery = () => {
    return useQuery({
        queryKey: ['viewAccountTeamMembersListQuery'],
        queryFn: () => {
            // sleep(2000);
            return clientPortalAxiosInstance
                .get(`/User-Profile/account/teamMembers`)
                .then((res) => res.data)
        },
    })
}

export const useGetTeamMemberByIdQuery = ({ staffId }) => {
    return useQuery({
        queryKey: ['getTeamMemberByIdQuery', `${staffId}`],
        queryFn: () => {
            // sleep(2000);
            return clientPortalAxiosInstance
                .get(`/User-Profile/account/teamMember/${staffId}`)
                .then((res) => {
                    return res.data
                })
        },
        // The query will not execute until the staffId exists
        enabled: !!staffId,
    })
}

export const useCreateTeamMemberMutation = () => {
    return useMutation({
        mutationFn: ({ body }) => {
            return clientPortalAxiosInstance.post(`/User-Profile/account/createTeamMember`, body)
        },
    })
}

/**
 * If you use PUT to upload file then you may use application/octet-stream as Content-Type. If you upload into Amazon S3 storage using multipart/formdata as Content-Type it will make your files (images, pdfs, documents) into text files with http header added on top. This will damage the content of the uploaded file. So use application/octet-stream when uploading binary files with PUT methods.
 */
export const useUploadProfilePicOfTeamMemberMutation = () => {

    return useMutation({
        mutationFn: ({ file }) => {
            /**file is single file and not array of files */

            const formData = new FormData();
            formData.append('file', file)

            return clientPortalAxiosInstance.post(`/client-referral/account/uploadProfilePicture`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })
        },
    })
}
export const useUpdateTeamMemberByIdMutation = () => {
    return useMutation({
        mutationFn: ({ body, staffId }) => {
            return clientPortalAxiosInstance.put(`/User-Profile/account/updateTeamMember/${staffId}`, body)
        },
    })
}
export const useDeleteTeamMemberByIdMutation = () => {
    return useMutation({
        mutationFn: ({ isDeleteMode, staffId }) => {
            return clientPortalAxiosInstance.delete(`/User-Profile/account/deleteTeamMember/${staffId}`, {
                data: {
                    IsDeleteMode: isDeleteMode
                }
            })
        },
    })
}